/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_1_AnswerInputs */

const en_svc_agents_faq_1_answer = /** @type {(inputs: Svc_Agents_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chatbot answers questions in a conversation. An AI agent takes steps: it reads an email, looks up the customer, updates the CRM and prepares a reply. Many of the systems we build combine both.`)
};

const lv_svc_agents_faq_1_answer = /** @type {(inputs: Svc_Agents_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čatbots atbild uz jautājumiem sarunā. AI aģents veic darbības: izlasa e-pastu, atrod klientu, atjaunina CRM un sagatavo atbildi. Daudzas mūsu veidotās sistēmas apvieno abus.`)
};

/**
* | output |
* | --- |
* | "A chatbot answers questions in a conversation. An AI agent takes steps: it reads an email, looks up the customer, updates the CRM and prepares a reply. Many ..." |
*
* @param {Svc_Agents_Faq_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_1_answer = /** @type {((inputs?: Svc_Agents_Faq_1_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_1_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_1_answer(inputs)
	return en_svc_agents_faq_1_answer(inputs)
});